export default __webpack_public_path__ + "static/media/RAGAVA.e373f8fe.jpeg";